import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';

@Directive({
    selector: '[dianaPreventDoubleClick]',
    standalone: false
})
export class PreventDoubleClickDirective {
  @Input() isPreventDoubleClickActive = true; // Default class name for disabling divs

  private isClicked = false;
  private disableDelay = 1000;
  private originalStyle: { [key: string]: string } = {}; // Store original styles

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  @HostListener('click', ['$event'])
  handleClick(event: Event): void {
    if (this.isPreventDoubleClickActive) {
      if (this.isClicked) {
        event.preventDefault();
        event.stopPropagation();
        return;
      } else {
        this.isClicked = true;
        const element = this.el.nativeElement;
        const tagName = element.tagName.toLowerCase();
        // without setTimeout the setAttribute(element, 'disabled', 'true') causes the button to ignore every clickEvent
        setTimeout(() => {
          if (tagName === 'button') {
            // getting the initial styles of the button because when disabled the button is gray out, this way its possible to to set back the colors of the button
            this.captureOriginalStyle();
            this.renderer.setAttribute(element, 'disabled', 'true');
            // setting back the color of button after has been disabled
            this.restoreOriginalStyle();
          } else {
            this.renderer.addClass(element, 'disabled');
          }
        });
       
        // Re-enable the button after a delay
        setTimeout(() => {
          this.isClicked = false;
          if (tagName === 'button') {
            this.renderer.removeAttribute(this.el.nativeElement, 'disabled');
          } else {
            this.renderer.removeClass(element, 'disabled');
          }
        
        }, this.disableDelay);
      }
    }

  }

  private captureOriginalStyle(): void {
    const computedStyle = window.getComputedStyle(this.el.nativeElement);

    // Save the styles that are modified by "disabled"
    this.originalStyle = {
      color: computedStyle.color,
      backgroundColor: computedStyle.backgroundColor,
      borderColor: computedStyle.borderColor,
      cursor: computedStyle.cursor,
    };
  }

  private restoreOriginalStyle(): void {
    // Restore each style property
    for (const [key, value] of Object.entries(this.originalStyle)) {
      this.renderer.setStyle(this.el.nativeElement, key, value);
    }
  }
}